export function getSearchesIds(searches, field) {
  try {
    return searches.map((search) => search[field])
  } catch (e) {
    return []
  }
}
